export default {
    url: '/courseresults?filterPrevMonth',
    abstract: true,
    template: '<ui-view></ui-view>',
    resolve: {
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise,
        employees (TokenService, UserResource, ROLE_CODE_ENUM) {
            return UserResource.query({
                roleCode: ROLE_CODE_ENUM.KEYS.EMPLOYEE,
                'siteIds[]': TokenService.getActiveSiteId(),
                pageSize: 0
            }).$promise;
        },
        sites: (SiteResource) => SiteResource.query({ reportUserResultsSites: true, pageSize: 0 }).$promise
    }

};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/courseresults/index.js